@if (showTable && jobLinkers) {
  <app-job-linker-list
    [jobLinkers]="jobLinkers"
    [showAdminControls]="forAdmin"
    [jobTypes]="jobTypes"
    [statuses]="statuses"
    [vendorJobSelectItems]="vendorJobSelectItems"
    (openJobLinkerToEdit)="openJobLinkerToEditClicked($event)"
    (jobLinkerDeleted)="jobLinkerDeleteClicked($event)"
    (showEdit)="toggleShowEditClicked($event)">
  </app-job-linker-list>
}

@if (showEdit) {
  <p-dialog
    header="Add or Update Job Linking"
    [(visible)]="showEdit"
    (onHide)="showEdit=false"
    [style]="{ width: '500px', minWidth: '350px' }">
    <app-job-linker-edit
      [jobLinkerToEdit]="jobLinkerToEdit"
      [companySelectItems]="companySelectItems"
      [vendorJobSelectItems]="vendorJobSelectItems"
      [consumerJobs]="consumerJobs"
      [jobTypes]="jobTypes"
      [statuses]="statuses"
      (jobLinkerAdded)="addJobLinker($event)"
      (jobLinkerUpdated)="updateJobLinker($event)"
      (closeEdit)="showEdit=false">
    </app-job-linker-edit>
  </p-dialog>
}
